import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CreateUserDto } from "./dto/createUserDto";
import { Observable } from "rxjs";
import { RestResponse } from "../../shared/RestResponse";
import { ListUserDto } from "./dto/listUserDto";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseUrl = `${environment.base_url}/users`;

  constructor(private http: HttpClient) {}

  create(dto: CreateUserDto): Observable<RestResponse<void>> {
    return this.http.post<RestResponse<void>>(`${this.baseUrl}/create`, dto);
  }

  list(
    search: string = '', 
    page: number = 1, 
    active: boolean | null = null, 
    canRequestRide: boolean | null = null,
    excludeRoleIds?: number[],
    roleIds?: number[]
  ): Observable<RestResponse<ListUserDto[]>> {
    let params: any = { page };
    
    if (search) {
      params.search = search;
    }
    
    if (excludeRoleIds && excludeRoleIds.length > 0) {
      params.excludeRoleIds = excludeRoleIds;
    }
    
    if (roleIds && roleIds.length > 0) {
      params.roleIds = roleIds;
    }
    
    if (active !== null) {
      params.active = active;
    }
    if (canRequestRide !== null) {
      params.canRequestRide = canRequestRide;
    }

    return this.http.get<RestResponse<ListUserDto[]>>(`${this.baseUrl}/list`, {params});
  }

  update(id: number, dto: CreateUserDto): Observable<RestResponse<CreateUserDto>> {
    return this.http.put<RestResponse<CreateUserDto>>(`${this.baseUrl}/update/${id}`, dto);
  }

  delete(id: number): Observable<RestResponse<void>> {
    return this.http.delete<RestResponse<void>>(`${this.baseUrl}/delete/${id}`);
  }

  getById(id: number): Observable<RestResponse<ListUserDto>> {
    return this.http.get<RestResponse<ListUserDto>>(`${this.baseUrl}/find/${id}`);
  }
}
